import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Postrequestcall } from "../../request/Postrequest";
import {
  FETCH_ONBOARDING_USER_EMAILS_EXISTS,
  CLIENT_SAVE_INVITATIONS,
  CLIENT_DETAILS_BY_USEREMAIL
  // CLIENT_DETAILS_BY_USERID
} from "../../constant/Apipath";
import Loader from "../../common/Loader";
import moment from "moment";
import { Box, Typography, Container, Paper } from "@mui/material";
import { toast } from "react-toastify";

const InvitationPage = () => {
  const { clientId, userEmail } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("Performing validation please wait");

  useEffect(() => {
    const validateInvitation = async () => {
      try {
        setLoading(true);

        // 1. Check if user exists
        const existsPayload = { UserEmail: userEmail };
        const existsRes = await Postrequestcall(
          FETCH_ONBOARDING_USER_EMAILS_EXISTS,
          existsPayload,
          null
        );

        // 2. Fetch client details (regardless of existence)
        const detailPayload = {
          UserEmail: userEmail,
          ClientId: Number(clientId)
        };
        const detailRes = await Postrequestcall(CLIENT_DETAILS_BY_USEREMAIL, detailPayload, null);

        if (existsRes?.status === 200 && detailRes?.status === 200) {
          const userExists = existsRes?.data?.data?.[0]?.isEmailExist === true;
          const rawData = detailRes?.data?.Data || detailRes?.data?.data;
          const inviteData = Array.isArray(rawData) ? rawData[0] : rawData;
          const currentStatus = inviteData?.invitationStatus;

          // 3. If already Accepted or Rejected, redirect
          if (currentStatus === "Accepted" || currentStatus === "Rejected") {
            setMessage(
              `Invitation already ${currentStatus.toLowerCase() === "accepted" ? "accepted" : "declined"}.`
            );
            setLoading(false);
            setTimeout(() => {
              navigate("/");
            }, 2000);
            return;
          }

          // 4. Determine intended action from URL params
          const isReject = searchParams.get("Reject") !== null;
          const status = isReject ? "Rejected" : "Accepted";

          if (userExists) {
            setMessage(isReject ? "Declining invite..." : "Accepting invite...");

            // Existing User: Process the invitation immediately
            const inviteObj = {
              id: 0,
              ClientId: Number(clientId),
              UserEmail: userEmail,
              Date: moment(),
              Status: status,
              Description: "User",
              GuideId: ""
            };

            const inviteRes = await Postrequestcall(CLIENT_SAVE_INVITATIONS, inviteObj, null);

            if (inviteRes?.status === 201 || inviteRes?.status === 200) {
              setMessage(`Invitation ${status} successfully!`);
              setTimeout(() => {
                navigate("/");
              }, 2000);
            } else {
              setMessage("Failed to process invitation. Please try again later.");
            }
          } else {
            // New User: Redirect to Create Account with invitation context
            setMessage("User not found. Fetching registration details...");

            const registrationState = {
              email: userEmail,
              clientId: clientId,
              clientData: detailRes?.data?.Data || detailRes?.data?.data,
              invitationStatus: status
            };

            navigate("/create-account", { state: registrationState });
          }
        } else {
          toast.error("Something went wrong. Please try again.");
          setMessage("Something went wrong. Please try again.");
        }
      } catch (error) {
        console.error("Error in InvitationPage:", error);
        setMessage("An error occurred while processing your invitation.");
      } finally {
        setLoading(false);
      }
    };

    if (userEmail && clientId) {
      validateInvitation();
    } else {
      setMessage("Invalid invitation link.");
      setLoading(false);
    }
  }, [clientId, userEmail, searchParams, navigate]);

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Paper elevation={3} sx={{ p: 4, width: "100%", textAlign: "center", borderRadius: 2 }}>
          {loading && <Loader />}
          <Typography variant="h6" color="textSecondary" sx={{ mt: loading ? 2 : 0 }}>
            {message}
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default InvitationPage;
